var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { includes } from 'lodash';
import * as moment from 'moment';
export var getInitials = function (name) {
    return name
        .replace(/[0-9]/g, '')
        .replace(/[&\/\\#,+()$~%.'\-":*?<>{}]/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim()
        .split(' ')
        .slice(0, 2)
        .map(function (letter) { return (letter[0] ? letter[0].toUpperCase() : ''); });
};
export var getVideoVersionDetails = function (videoDetails) {
    return Object.keys(videoDetails.perVersion).reduce(function (r, v) {
        var tempV = __assign(__assign({}, videoDetails.perVersion[v].perLanguage[videoDetails.perVersion[v].originalLanguage]), { id: videoDetails.perVersion[v].originalLanguage + "-" + v, lang: videoDetails.perVersion[v].originalLanguage, format: videoDetails.perVersion[v].format, isOriginal: true, version: v, status: videoDetails.perVersion[v].status, items: Object.keys(videoDetails.perVersion[v].perLanguage)
                .filter(function (key) {
                return key !== videoDetails.perVersion[v].originalLanguage &&
                    videoDetails.perVersion[v].langList.find(function (l) { return l.id === key; });
            })
                .map(function (key) { return (__assign(__assign({}, videoDetails.perVersion[v].perLanguage[key]), { format: videoDetails.perVersion[v].format, id: key + "-" + v, parent: videoDetails.perVersion[v].originalLanguage + "-" + v, version: v, lang: key })); }) });
        return __spreadArray(__spreadArray([], r), [tempV]);
    }, []);
};
export var convertHexToRGBA = function (hexCode, opacity) {
    var hex = hexCode.replace('#', '');
    if (hex.length === 3) {
        hex = "" + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
};
/**
 * Get the copy of object without attributes.
 *
 * @param {any} obj
 * @param {any[]} attrsToExclude
 * @returns {T}
 */
export function withoutAttrs(obj, attrsToExclude) {
    if (Array.isArray(obj)) {
        throw new TypeError('withoutAttrs() expects first argument to be a plain object, array given.');
    }
    var result = {};
    Object.keys(obj).forEach(function (key) {
        if (!includes(attrsToExclude, key)) {
            result[key] = obj[key];
        }
    });
    return result;
}
/**
 * Returns the string by removing the skip translations characters [ ] from the string
 *
 * @param {string} data
 * @returns {string}
 */
export var replaceTranslationSkipCharacters = function (data) {
    return typeof data === 'string' ? (data || '').replace(/\[|]/g, '') : data;
};
/**
 * Returns the tag which are added as break in polly. eg. <break time="5s"/> is converted to empty string.
 *
 * @param {string} data
 * @returns {string}
 */
export var replaceBreaks = function (data) {
    return typeof data === 'string' ? (data || '').replace(/<break(.*?)>/g, '') : data;
};
/**
 * Checks if the email belongs to a LP user. Lp users are the ones with `@launchpeople.com` or `@trainingtube.com` emails.
 *
 * @param {string} email
 * @returns {boolean}
 */
export var isLPUser = function (email) {
    return includes(email, '@trainingtube.com') || includes(email, '@launchpeople.com');
};
/**
 * Formats date to the format used in the app.
 *
 * @param {string} date
 * @returns {string}
 */
export var formatDate = function (date) {
    return moment(new Date(date)).format('YYYY-MM-DD HH:mm');
};
export var formatDateWithoutTime = function (date) {
    return moment(new Date(date)).format('YYYY-MM-DD');
};
/**
 * Build supplied string by interpolating properties inside delimiters('{ }') with the given parameters.
 *
 * @example
 * interpolate('{name} is here.', {name: 'Barbara'})
 *  => 'Barbara is here.'
 *
 * @param {string} str
 * @param {object} params
 * @returns {string}
 */
export function interpolate(str, params) {
    var formattedString = str;
    if (!params || !Object.keys(params)) {
        return str;
    }
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (value === null || value === undefined) {
            continue;
        }
        formattedString = formattedString.replace(new RegExp('{' + key + '}', 'gi'), value.toString());
    }
    return formattedString;
}
export var checkIfDevelopmentStage = function () {
    return (window.location.href.indexOf('localhost') !== -1 ||
        window.location.href.indexOf(':3000') !== -1 ||
        window.location.href.indexOf('tt-react-dev') !== -1 ||
        window.location.href.indexOf('tt-react-test') !== -1 ||
        window.location.href.indexOf('.dev.trainingtube.com') !== -1 ||
        window.location.href.indexOf('https://trainingtube.trainingtube.com') !== -1);
};
export var isCurrentPageAdminOrUserTasksPage = function () {
    return ((window.location.pathname.includes('/tasks') ||
        window.location.pathname.includes('/admin/operationalTasks') ||
        window.location.pathname.includes('/support/chat') ||
        window.location.pathname.includes('/admin/tasks')) &&
        !window.location.pathname.includes('/channel'));
};
export var isCurrentPageNotificationPage = function () {
    return window.location.pathname.includes('/notifications');
};
export var handleSidebarChange = function (tableData, filters) {
    var data = tableData
        .filter(function (task) {
        return filters.status.includes(task.status);
    })
        .filter(function (item) {
        return filters.category.includes(item.category);
    })
        .filter(function (item) {
        return item.taskSubType && item.taskSubType !== 'N/A' ? filters.taskSubType.includes(item.taskSubType) : true;
    })
        .filter(function (item) {
        return filters.type.includes(item.taskType);
    });
    return data;
};
export function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    var functions = funcs.reverse();
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var firstFunction = functions[0], restFunctions = functions.slice(1);
        var result = firstFunction.apply(null, args);
        restFunctions.forEach(function (fnc) {
            result = fnc.call(null, result);
        });
        return result;
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/common.ts
// module id = 32
// module chunks = 81